import { render, staticRenderFns } from "./EntriesInventories.vue?vue&type=template&id=2a85ab6c&"
import script from "./EntriesInventories.vue?vue&type=script&lang=js&"
export * from "./EntriesInventories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports